export default "__VITE_ASSET__b4f0b2d0__"